var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoveIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4853",
    "data-name": "Rectangle 4853",
    width: 20.185,
    height: 20.194,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13289",
    "data-name": "Group 13289",
    transform: "translate(-839 -994)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_569",
    "data-name": "Ellipse 569",
    transform: "translate(839 994)",
    fill: "#014fe0",
    stroke: "#fff",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13248",
    "data-name": "Group 13248",
    transform: "translate(845.406 999.902)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12174",
    "data-name": "Group 12174",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45228",
    "data-name": "Path 45228",
    d: "M0,141.152a3.691,3.691,0,0,1,.331-.455c.718-.731,1.446-1.453,2.171-2.177a.6.6,0,0,1,.986-.005c.065.065.132.128.195.2a.568.568,0,0,1,0,.857c-.273.284-.553.561-.863.875H5.966a.589.589,0,0,1,.658.653c0,.105,0,.21,0,.315a.578.578,0,0,1-.605.606c-1,0-2,0-3,0H2.776c.046.057.072.1.105.131.25.252.5.5.751.754a.569.569,0,0,1,0,.856c-.081.086-.165.169-.251.251a.572.572,0,0,1-.871,0c-.449-.443-.893-.891-1.339-1.337-.274-.274-.554-.542-.82-.825A5.64,5.64,0,0,1,0,141.388v-.237",
    transform: "translate(0 -131.129)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45229",
    "data-name": "Path 45229",
    d: "M140.881,269.589c-.145-.119-.3-.228-.434-.36q-1.044-1.033-2.079-2.075c-.356-.357-.343-.631-.006-1,.442-.487.8-.5,1.228-.006a5.036,5.036,0,0,0,.7.657V266.6c0-.986.011-1.971-.006-2.957a.669.669,0,0,1,.686-.685c.721-.016.921.227.9.9-.025.9-.006,1.8-.006,2.7v.251c.255-.257.485-.468.691-.7.467-.528.813-.47,1.241,0a.607.607,0,0,1,0,.987q-1.121,1.123-2.245,2.243a3.663,3.663,0,0,1-.316.253Z",
    transform: "translate(-130.983 -249.394)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45230",
    "data-name": "Path 45230",
    d: "M266.725,142.071c-1.1,0-2.138-.015-3.175.007a.663.663,0,0,1-.717-.708c-.007-.665.188-.9.895-.882.958.028,1.917.007,2.908.007a1.442,1.442,0,0,0-.1-.129c-.246-.246-.5-.489-.739-.737a.569.569,0,0,1-.007-.87c.086-.09.173-.18.265-.264a.563.563,0,0,1,.829,0c.234.221.457.453.685.68q.822.822,1.644,1.643a.608.608,0,0,1,0,.987q-1.107,1.108-2.215,2.214a.6.6,0,0,1-.958,0c-.514-.468-.538-.794-.009-1.266.228-.2.437-.43.7-.687",
    transform: "translate(-249.28 -131.182)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45231",
    "data-name": "Path 45231",
    d: "M140.428,2.746c-.3.3-.562.565-.825.827a.612.612,0,0,1-.974,0c-.508-.46-.5-.784,0-1.257.7-.665,1.37-1.362,2.053-2.045A.616.616,0,0,1,141.7.265q1.123,1.121,2.244,2.244a.6.6,0,0,1,.005.974c-.448.489-.774.543-1.253.008-.2-.229-.434-.436-.689-.689v.244q0,1.459,0,2.917c0,.459-.212.667-.677.668h-.276a.583.583,0,0,1-.622-.63q0-1.5,0-3Z",
    transform: "translate(-131.122 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45232",
    "data-name": "Path 45232",
    d: "M166.774,165.328a1.576,1.576,0,1,1-1.588,1.565,1.578,1.578,0,0,1,1.588-1.565",
    transform: "translate(-156.668 -156.803)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveIconWhite);
export default __webpack_public_path__ + "static/media/move_icon_white.15d134260025fd6aec751e59d52ec974.svg";
export { ForwardRef as ReactComponent };